import script from "./DataList.vue?vue&type=script&setup=true&lang=js"
export * from "./DataList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/dataList.css?vue&type=style&index=0&id=4b52dfa4&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b52dfa4"]])

export default __exports__